
<script>
// 近期比赛
import { QNImageUtil } from '@/utils'
import { goGameDetail } from '@/utils/goGameDetail'

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
      return {
        wheelBattleIconUrl: 'https://images.snsports.cn/Fmapyv1dN1-f7Mj4S5iVL2UwnMbb'
      };
  },
  methods: {
    isWheelBattle(item) {
      return item && Number(item.gameMode) === 1
    },
    getLogoUrl(url) {
      return QNImageUtil.originView(url) || ''
    },
    onItemClick(item) {
      goGameDetail(this.$router, item)
    },
    hasScore(v) {
      if (v == null || v === '') return false
      if (Number(v) === -1) return false
      return true
    },
  },
};
</script>

<template>
  <div class="recent-games-container flex">
    <div class="recent-games-item bg2 padding-12" v-for="item in list" :key="item.id" @click="onItemClick(item)">
      <div v-if="!(item.type === 'game' && isWheelBattle(item))" class="name font-color3 overflow-text">{{ item.name }}</div>
      <div v-else class="name font-color3 overflow-text">{{ item.group }}</div>
      <div class="team-box wheel-battle-box vertical-center" v-if="item.type === 'game' && isWheelBattle(item)">
        <img class="wheel-battle-icon" :src="wheelBattleIconUrl" alt="" />
        <div class="wheel-battle-info">
          <div class="wheel-battle-name overflow-text">{{ item.name }}</div>
          <div class="wheel-battle-tag">限时</div>
        </div>
      </div>
      <div class="team-box" v-else-if="item.type === 'game'">
        <div class="team-info vertical-center">
          <img class="logo" v-if="item.home.logUrl" :src="getLogoUrl(item.home.logUrl)" alt="logo" />
          <div class="team-name overflow-text">{{ item.home.name }}</div>
          <div class="score" v-if="hasScore(item.home.score)">{{ item.home.score }}</div>
        </div>
        <div class="team-info vertical-center">
          <img class="logo" v-if="item.away.logUrl" :src="getLogoUrl(item.away.logUrl)" alt="logo" />
          <div class="team-name overflow-text">{{ item.away.name }}</div>
          <div class="score" v-if="hasScore(item.away.score)">{{ item.away.score }}</div>
        </div>
      </div>
      <div v-else class="activity-name overflow-text-two">
        <img class="activity-icon" src="https://images.snsports.cn/Fn_60JJYiJSVjgy4_mDIzA5L26JY">
        {{ item.name }}
      </div>
      <div class="bottom flex">
        <div class="status text-center color-white" :class="`status-${item.status}`" v-if="item.status != -1">{{ item.statusLabel }}</div>
        <div class="time font-color3">{{ item.time }}</div>
      </div>
    </div>
  </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.recent-games-container {
  overflow-x: scroll;
  &::-webkit-scrollbar { display: none; }
}
.recent-games-item {
  min-width: 245px;
  border-radius: 4px;
  height: 125px;
  box-sizing: border-box;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
  .name { font-size: 13px; margin-bottom: 3px; }
  .wheel-battle-box {
    height: 64px;
    gap: 10px;
    padding: 0 8px;
  }
  .wheel-battle-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
    display: block;
  }
  .wheel-battle-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .wheel-battle-name {
    font-size: 15px;
    color: #333;
    line-height: 21px;
  }
  .wheel-battle-tag {
    display: inline-block;
    align-self: flex-start;
    margin-top: 4px;
    padding: 1px 6px;
    font-size: 11px;
    line-height: 16px;
    color: #e6a23c;
    background: #fdf0e8;
    border-radius: 2px;
  }
  .team-box .team-info {
    height: 20px;
    padding: 6px 8px;
    .logo {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      margin-right: 7px;
    }
    .team-name {
      font-size: 15px;
      flex: 1;
      margin-right: 7px;
    }
    .score { color: #16447C; font-size: 17px; }
  }
  .activity-name{
    height: 64px;
    display: flex;
    align-items: center;
    font-size: 16px;
    img{
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  .bottom {
    margin-top: 3px;
    .status {
      width: 47px;
      height: 18px;
      font-size: 11px;
      line-height: 18px;
      border-radius: 2px;
      margin-right: 8px;
    }
    .status-0{
      background-color: #E6A23C;
    }
    .status-1{
      background-color: #C30D23;
    }
    .status-2{
      background-color: #529B2E;
    }
    .time{
      font-size: 13px;
    }
  }
}
</style>
